module.exports = "i {\n  margin-right: 5px; }\n\nimg {\n  max-width: 50px; }\n\nbutton {\n  display: block;\n  margin-bottom: 5px; }\n\n.content {\n  font-size: 0.9em;\n  padding-right: 15px; }\n\n.stripe-text {\n  color: #209cee;\n  font-weight: bold; }\n\n.firebase-text {\n  color: #ffac33;\n  font-weight: bold; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/user-login/user-login.component.sass
// module id = ./src/app/shared/user-login/user-login.component.sass
// module chunks = main